import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Server03 = function Server03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m22 17.5-.6917-10.0302c-.1086-1.5748-.1629-2.3621-.5042-2.959a3 3 0 0 0-1.2979-1.2114C18.8873 3 18.0981 3 16.5196 3H7.4804c-1.5785 0-2.3677 0-2.9866.2994a3 3 0 0 0-1.2979 1.2114c-.3413.5969-.3956 1.3842-.5042 2.959L2 17.5m20 0c0 1.933-1.567 3.5-3.5 3.5h-13C3.567 21 2 19.433 2 17.5m20 0c0-1.933-1.567-3.5-3.5-3.5h-13C3.567 14 2 15.567 2 17.5m4 0h.01m5.99 0h6"
    })
  }));
};
export default Server03;